import React from 'react';
import styled from 'styled-components';
import { IconBase } from '../Base';
const Head = styled.path `
  transform-origin: 3.75px 8px;
`;
export const IconUser = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("g", { fill: "none", strokeWidth: "1.5", style: { stroke: 'var(--icon-color)' } },
            React.createElement(Head, { d: "M13.75 6C13.75 8.20914 12.2091 10 10 10C7.79086 10 6.25 8.20914 6.25 6C6.5 3.79086 8.23411 2.5 10 2.5C11.7659 2.5 13.5 3.79086 13.75 6Z" }),
            React.createElement("path", { d: "M3.25 15.9C3.25 14.0222 4.77223 12.5 6.65 12.5H13.35C15.2278 12.5 16.75 14.0222 16.75 15.9V16.5C16.75 17.0523 16.3023 17.5 15.75 17.5H4.25C3.69772 17.5 3.25 17.0523 3.25 16.5V15.9Z" }))));
};
//# sourceMappingURL=User.js.map